<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { inject, watch, onBeforeUnmount } from "vue";
import {
  useMagicDrawer,
  useMagicEmitter
} from "@maas/vue-equipment/plugins";
import { useMagicCommand } from "../composables/useMagicCommand";
import { MagicCommandInstanceId } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "MagicCommandDrawer",
  props: {
    options: { type: null, required: false }
  },
  setup(__props) {
    const instanceId = inject(MagicCommandInstanceId, "");
    const emitter = useMagicEmitter();
    if (!instanceId) {
      throw new Error(
        "MagicCommandDrawer must be nested inside MagicCommandProvider"
      );
    }
    function afterLeaveCallback(payload) {
      if (typeof payload === "string" && payload === instanceId) {
        close();
      }
    }
    const { close, isActive } = useMagicCommand(instanceId);
    const drawerApi = useMagicDrawer(instanceId);
    watch(isActive, (value) => {
      if (value) {
        drawerApi.open();
      } else {
        drawerApi.close();
      }
    });
    emitter.on("afterLeave", afterLeaveCallback);
    onBeforeUnmount(() => {
      emitter.off("afterLeave", afterLeaveCallback);
      close();
    });
    return (_ctx, _cache) => {
      const _component_magic_drawer = _resolveComponent("magic-drawer");
      return _openBlock(), _createBlock(_component_magic_drawer, _mergeProps({
        id: _unref(instanceId),
        class: "magic-command-drawer",
        options: _ctx.options
      }, _ctx.$attrs), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
        /* FORWARDED */
      }, 16, ["id", "options"]);
    };
  }
});
</script>
